import { ApiResponse, CaseData, HttpResponse } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint } from 'app/area/case/endpoints';
import { primaryKey } from 'app/infrastructure/data/wireformat';

export const api = {  

  callsToActions: async (id: number): Promise<any> => {
    const response = await new RemoteData(endpoint.callsToActions(id))
      .resource<ApiResponse<any>>()
      .filter({ caseId: id })
      .single();

    return response.data;
  },

  case: async (id: number): Promise<HttpResponse<CaseData>> => {    
    return new RemoteData(endpoint.case).resource<HttpResponse<CaseData>>()
      .withId(id)
      .response();
  },

  changeCaseStatus: async (data: CaseData, eTag: string, includeFailedConstraints: boolean = false, allowWarnings: boolean = true) => {
    return new RemoteData(endpoint.case)
      .resource<HttpResponse<CaseData>>()
      .withId(primaryKey(data))
      .withIfMatch(eTag)
      .filter({ includeFailedConstraints, allowWarnings })
      .save(data);
  }
};
